import {
  Component,
  Input,
  EventEmitter,
  OnChanges,
  Output,
} from '@angular/core';

import { Grid } from '../../../lib/grid';
import { Row } from '../../../lib/data-set/row';
import { DataSource } from '../../../lib/data-source/data-source';

@Component({
    selector: 'ng2-st-tbody-create-cancel',
    template: `
      @if (showUpdate) {
        <a href="#" class="ng2-smart-action ng2-smart-action-edit-save"
           [innerHTML]="saveButtonContent"
           (click)="onSave($event)">
        </a>
      }
      <a href="#" class="ng2-smart-action ng2-smart-action-edit-cancel"
        [innerHTML]="cancelButtonContent"
        (click)="onCancelEdit($event)">
      </a>
    `,
    standalone: false
})
export class TbodyCreateCancelComponent implements OnChanges {
  @Input() public source: DataSource;
  @Input() public grid: Grid;
  @Input() public row: Row;
  @Input() public editConfirm: EventEmitter<any>;

  @Output() public cancelUpdate = new EventEmitter<any>();

  public cancelButtonContent: string;
  public saveButtonContent: string;
  public showUpdate: boolean;

  public onSave(event: any) {
    event.preventDefault();
    event.stopPropagation();

    this.grid.save(this.row, this.editConfirm);
  }

  public onCancelEdit(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.row.isInEditing = false;
    this.row.isDeleted = false;
    this.row.isReissued = false;
    this.row.isRevoked = false;
    this.row.isUndo = false;
    // on cancel edit setting the formcontrols to initial row values
    if (!this.row.isNewRow) {
      // tslint:disable-next-line:forin
      for (let k in this.row.getValidator().controls) {
        this.row.getValidator().controls[k].setValue(this.row.getData()[k]);
      }
      this.row.highlighted = false;
    }
    if (this.grid.getSetting('mode') === 'custom') {
      this.cancelUpdate.emit({
        index: this.row.index,
        data: this.row.getData(),
      });
    }
  }

  public ngOnChanges() {
    this.saveButtonContent = this.grid.getSetting('edit.saveButtonContent');
    if (this.row.isNewRow) {
      this.cancelButtonContent = this.grid.getSetting(
        'add.cancelButtonContent',
      );
    } else if (this.row.isInEditing) {
      this.cancelButtonContent = this.grid.getSetting(
        'edit.cancelButtonContent',
      );
    } else if (this.row.isDeleted) {
      this.cancelButtonContent = this.grid.getSetting(
        'delete.cancelButtonContent',
      );
    } else if (this.row.isReissued) {
      this.cancelButtonContent = this.grid.getSetting(
        'reissue.cancelButtonContent',
      );
    } else if (this.row.isRevoked) {
      this.cancelButtonContent = this.grid.getSetting(
        'revoke.cancelButtonContent',
      );
    } else if (this.row.isUndo) {
      this.cancelButtonContent = this.grid.getSetting(
        'undo.cancelButtonContent',
      );
    }
    this.showUpdate = !(this.grid.getSetting('mode') === 'custom');
  }
}
